<div class="formsReport-filter">
  <div
    class="formsReport-filter__header"
    (click)="filterService.toggleExpanded()"
    [ngClass]="{ 'formsReport-filter__header--expanded': filterService.isFilterExpanded }"
  >
    <div class="formsReport-filter__header__title">
      <mat-icon>filter_alt</mat-icon>
      {{ 'DASHBOARD_FORMS.FILTERS.TITLE' | translate }}
    </div>

    <div class="formsReport-filter__header__expand">
      <span *ngIf="filterService.isFilterExpanded">{{ 'DASHBOARD_FORMS.FILTERS.SEE_LESS' | translate }}</span>
      <span *ngIf="!filterService.isFilterExpanded">{{ 'DASHBOARD_FORMS.FILTERS.SEE_MORE' | translate }}</span>
    </div>
  </div>

  <div class="formsReport-filter__content" *ngIf="filterService.isFilterExpanded">
    <div class="formsReport-filter__content__date">
      <div class="formsReport-filter__content__date__text">
        {{ 'DASHBOARD_FORMS.FILTERS.FILTER_BY.DATE' | translate }}
      </div>
      <fc-date-input
        [control]="filterService.filterForm.get('initialDate')"
        [placeholder]="'DASHBOARD_FORMS.FILTERS.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="DASHBOARD_FORMS.ERRORS"
        [max]="filterService.filterForm.get('finalDate').value"
      ></fc-date-input>

      <div class="formsReport-filter__content__date__text">
        {{ 'DASHBOARD_FORMS.FILTERS.TO' | translate }}
      </div>

      <fc-date-input
        [control]="filterService.filterForm.get('finalDate')"
        [placeholder]="'DASHBOARD_FORMS.FILTERS.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="DASHBOARD_FORMS.ERRORS"
        [min]="filterService.filterForm.get('initialDate').value"
      ></fc-date-input>
    </div>
    <fc-maintenance-types-input
      [control]="filterService.filterForm.get('maintenanceTypes')"
    ></fc-maintenance-types-input>

    <fc-segments-input [control]="filterService.filterForm.get('segments')"></fc-segments-input>

    <div class="formsReport-filter__content__input-group">
      <div class="formsReport-filter__content__input-group__locations">
        <fc-locations-input [control]="filterService.filterForm.get('locations')"> </fc-locations-input>
      </div>
      <fc-location-groups-input [control]="filterService.filterForm.get('locationGroups')"></fc-location-groups-input>
      <fc-companies-input [control]="filterService.filterForm.get('companies')"></fc-companies-input>
      <div class="search">
        <fc-text-input
          class="search__input"
          [control]="filterService.filterForm.get('formContent')"
          [label]="'DASHBOARD_FORMS.FILTERS.FILTER_BY.FORM_CONTENT' | translate"
        ></fc-text-input>
      </div>
    </div>
  </div>
</div>
